module.exports = __webpack_public_path__ + "img/stars-bg.1b49bfbb.png";